export default "__VITE_ASSET__5d34fbc3__"